import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { GridIcon } from 'foundations-assets/icons/components/GridIcon';
import { TrellisHorizontalEdgeToolbar as HorizontalEdgeToolbar } from 'layout-dnd-components/DndToolbar/HorizontalEdgeToolbar';
// @ts-expect-error not typed
import { getEmptyImage } from 'react-dnd-ipeui-backend';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { buildDeleteAction, buildDuplicateAction, buildEditStylesAction, buildHideOnMobileAction, useGridToggleNodeVisibilityOnThisBreakpoint } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default function BaseGridTableToolbar({
  toolbarInfo,
  active,
  responsiveSize,
  isDraggable = true,
  isInNonDefaultBreakpointMode,
  connectDragSource,
  connectDragPreview,
  onHandleMouseDown,
  onDropdownOpenChange
}) {
  const dispatch = useDispatch();
  const toggleNodeVisibilityOnThisBreakpoint = useGridToggleNodeVisibilityOnThisBreakpoint(toolbarInfo);
  useEffect(() => {
    if (!connectDragPreview) {
      return;
    }
    connectDragPreview(getEmptyImage(), {
      captureDraggingState: true
    });
  }, [connectDragPreview]);
  const tableActions = useMemo(() => {
    const actions = [buildEditStylesAction('grid', dispatch, toolbarInfo, /*#__PURE__*/_jsx(FormattedMessage, {
      message: "inpage.actionToolbar.grid.editStyles"
    }))];
    if (!isInNonDefaultBreakpointMode) {
      actions.push(buildDuplicateAction('grid', dispatch, toolbarInfo, /*#__PURE__*/_jsx(FormattedMessage, {
        message: "inpage.actionToolbar.grid.clone"
      })), buildDeleteAction('grid', dispatch, toolbarInfo, /*#__PURE__*/_jsx(FormattedMessage, {
        message: "inpage.actionToolbar.grid.delete"
      })));
    } else {
      actions.push(buildHideOnMobileAction('grid', /*#__PURE__*/_jsx(FormattedMessage, {
        message: "inpage.actionToolbar.grid.hide"
      }), toggleNodeVisibilityOnThisBreakpoint));
    }
    return actions;
  }, [dispatch, toolbarInfo, isInNonDefaultBreakpointMode, toggleNodeVisibilityOnThisBreakpoint]);
  const styleActionIndex = tableActions.findIndex(action => action.id === 'grid-styles');
  const iconClickHandler = styleActionIndex === -1 || tableActions[styleActionIndex].disabled ? undefined : tableActions[styleActionIndex].callback;
  return /*#__PURE__*/_jsx(HorizontalEdgeToolbar, {
    active: active,
    icon: GridIcon,
    actions: tableActions,
    position: "absolute",
    zIndex: 5,
    insetInlineStart: `${Math.round((toolbarInfo === null || toolbarInfo === void 0 ? void 0 : toolbarInfo.left) || 0)}px`,
    insetBlockStart: `${Math.round((toolbarInfo === null || toolbarInfo === void 0 ? void 0 : toolbarInfo.top) || 0)}px`,
    handleTooltipPlacement: "top right",
    responsiveSize: responsiveSize,
    variant: "primary",
    handleTooltip: I18n.text('inpage.tile.grid.label'),
    onDropdownOpenChange: onDropdownOpenChange,
    onHandleMouseDown: onHandleMouseDown,
    onHandleClick: iconClickHandler,
    handleButtonStyles: {
      cursor: isDraggable ? 'move' : 'default'
    },
    handleButtonRef: handleButtonElement => {
      if (handleButtonElement && connectDragSource) {
        connectDragSource(handleButtonElement);
      }
    }
  });
}